<section class="contact-top">
    
    <div class="inner_sec">

       <div class="container">     
        <h2>Auxiliary Equipment.</h2>
       </div> 
             
        <div class="tabbing_sec">

        <div class="product_list">

            <div class="product_box conveyer_sec">
              <div class="container">
                <h3>Plastic Manufacturing</h3>
                <div class="row">   
                    <div class="col-sm-3" *ngFor="let data of conveyersystem">
                        <div class="productItem">
                            <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                            <h4>{{data.title}}</h4>
                        </div>
                    </div>
                </div>
              </div>
            </div>

            <div class="product_box material_movement">
            <div class="container">
                <h3>Plastic Mold Manufacturing</h3>
                <div class="row">   
                    <div class="col-sm-4" *ngFor="let data of materialmove">
                        <div class="productItem">
                            <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                            <h4>{{data.title}}</h4>
                        </div>
                    </div>
                </div>
            </div>
            </div>

           <div class="product_box material_storage">
            <div class="container">
                <h3>Chillers & Cooling System</h3>
                <div class="row">   
                    <div class="col-sm-4" *ngFor="let data of materialstorage">
                        <div class="productItem">
                            <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                            <h4>{{data.title}}</h4>
                        </div>
                    </div>
                </div>
            </div>
           </div>

           <div class="product_box material_storage">
            <div class="container">
                <h3>Air Compressor Solutions</h3>
                <div class="row">   
                    <div class="col-sm-3" *ngFor="let data of aircompress">
                        <div class="productItem">
                            <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                            <h4>{{data.title}}</h4>
                        </div>
                    </div>
                </div>
            </div>
           </div>

           <div class="product_box material_storage">
            <div class="container">
                <h3>Vacuum Pump and Accessories</h3>
                <div class="row">   
                    <div class="col-sm-4" *ngFor="let data of vaccum">
                        <div class="productItem">
                            <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                            <h4>{{data.title}}</h4>
                        </div>
                    </div>
                </div>
            </div>
           </div>

        </div>
              
        </div>
    </div>

</section>
